import useAppNavigation from 'apps/employer_renewals/hooks/useAppNavigation'
import { useUser } from 'apps/employer_renewals/providers/UserProvider'
import { DropdownMenu, ProfileMenuToggle } from 'slab'

export default function ProfileMenuToolbar () {
  const { userName } = useUser()
  const { goToDashboard } = useAppNavigation()

  return (
    <div className='sticky top-0 z-20 border-b border-gray-200 backdrop-blur-md shrink-0 px-3 xs:px-5 py-3'>
      <DropdownMenu trigger={<ProfileMenuToggle>{userName}</ProfileMenuToggle>}>
        <DropdownMenu.Item onSelect={() => goToDashboard()}>
          Back to dashboard
        </DropdownMenu.Item>
      </DropdownMenu>
    </div>
  )
}
